import React, {useEffect, useRef, useState} from 'react'
import download from 'downloadjs'
import axios from 'axios'
import {DirectorioBanner} from '../../components/Directorio/DirectorioBanner'

function Directorio() {
  const urlCsv = 'https://puntosurgdl.com/backend/downloadCSV.php'
  const urlSVGnivel1 = 'https://puntosurgdl.com/backend/downloadSVGnivel1.php'
  const urlSVGnivel2 = 'https://puntosurgdl.com/backend/downloadSVGnivel2.php'
  const urlSVGplantabaja = 'https://puntosurgdl.com/backend/downloadSVGplantabaja.php'
  const urlSVGsotano = 'https://puntosurgdl.com/backend/downloadSVGsotano.php'

  const url = 'https://puntosurgdl.com/backend/'

  const [checkDevMode, setCheckDevMode] = useState(false)
  const [showAlertSuccess, setShowAlertSuccess] = useState(false)

  const clearTimerRef = useRef()

  useEffect(() => {
    getDirectorioDevMode()
  }, [])

  const onChangeDevMode = (event) => {
    let columnIsActive = false

    if (event.target.checked) {
      console.log('is checked')
      columnIsActive = 1
    } else {
      console.log('is NOT checked')
      columnIsActive = 0
    }

    console.log(columnIsActive)

    const data = {
      name: 'directorio-dev-mode',
      content: columnIsActive,
    }

    axios
      .post(url + 'updateColumnIsActive.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res)
          setCheckDevMode(columnIsActive)
        },
        (error) => {
          alert(error)
        }
      )
  }

  const getDirectorioDevMode = () => {
    axios
      .get(url + 'directorioDevMode.php')
      .then((response) => {
        let generalElements = response.data.data[0]

        //console.log(generalElements.content)

        setCheckDevMode(generalElements.content)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const downloadCSV = async (urlCsv, name) => {
    const response = await fetch(urlCsv)
    const data = await response.text()
    const blob = new Blob([data], {type: 'data:text/csv;charset=utf-8,'})
    const blobURL = window.URL.createObjectURL(blob)

    // Create new tag for download file
    const anchor = document.createElement('a')
    anchor.download = name
    anchor.href = blobURL
    anchor.dataset.downloadurl = ['text/csv', anchor.download, anchor.href].join(':')
    anchor.click()

    // Remove URL.createObjectURL. The browser should not save the reference to the file.
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      URL.revokeObjectURL(blobURL)
    }, 100)
  }

  const downloadSVG = async (urlCsv, name) => {
    const response = await fetch(urlCsv)
    const data = await response.text()
    const blob = new Blob([data], {type: 'data:image/svg+xml;'})
    const blobURL = window.URL.createObjectURL(blob)

    // Create new tag for download file
    const anchor = document.createElement('a')
    anchor.download = name
    anchor.href = blobURL
    anchor.dataset.downloadurl = ['image/svg+xml', anchor.download, anchor.href].join(':')
    anchor.click()

    // Remove URL.createObjectURL. The browser should not save the reference to the file.
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      URL.revokeObjectURL(blobURL)
    }, 100)
  }

  const downloadCSVV = () => {
    const mode = {method: 'GET', mode: 'no-cors'}
    fetch(urlCsv, mode)
      .then((res) => res.text())
      .then((data) => download(data, 'texto.csv', 'text/csv'))
  }

  const uploadCsv = () => {
    const data = new FormData()

    if (document.getElementById('directorio-csv-file').files.length !== 0) {
      setShowAlertSuccess(false)
      clearTimeout(clearTimerRef.current)

      for (let i = 0; i < document.getElementById('directorio-csv-file').files.length; i++) {
        data.append('file[]', document.getElementById('directorio-csv-file').files[i])
      }

      axios
        .post(url + 'uploadCSV.php', data, {
          // receive two parameter endpoint url ,form data
        })
        .then(
          (res) => {
            // then print response status
            // console.log(res.data)
            // setConceptos(res.data.data)
            // handleCloseNewConcepto()
            // console.log(res.data)
            // document
            //   .getElementById('lifestyle-img-fondo')
            //   .setAttribute('src', res.data.data[1].url)
            document.getElementsByName('directorio-csv-file')[0].value = null
            setShowAlertSuccess(true)

            clearTimerRef.current = setTimeout(function () {
              setShowAlertSuccess(false)
            }, 3000)
            // setSpinnerIsActive(false)
          },
          (error) => {
            alert(error)
          }
        )
    } else {
      console.log('vacío')
    }
  }

  const uploadSVG = (name) => {
    const data = new FormData()

    if (document.getElementById('directorio-svg-' + name).files.length !== 0) {
      setShowAlertSuccess(false)
      clearTimeout(clearTimerRef.current)

      for (let i = 0; i < document.getElementById('directorio-svg-' + name).files.length; i++) {
        data.append('file[]', document.getElementById('directorio-svg-' + name).files[i])
      }

      axios
        .post(url + 'uploadSVG.php', data, {
          // receive two parameter endpoint url ,form data
        })
        .then(
          (res) => {
            document.getElementsByName('directorio-svg-' + name)[0].value = null
            setShowAlertSuccess(true)

            clearTimerRef.current = setTimeout(function () {
              setShowAlertSuccess(false)
            }, 3000)
            // setSpinnerIsActive(false)
          },
          (error) => {
            alert(error)
          }
        )
    } else {
      console.log('vacío')
    }
  }

  const uploadImage = () => {
    const data = new FormData()

    console.log(document.getElementById('img-file').files[0])

    if (document.getElementById('img-file').files.length !== 0) {
      setShowAlertSuccess(false)
      clearTimeout(clearTimerRef.current)

      for (let i = 0; i < document.getElementById('img-file').files.length; i++) {
        data.append('file[]', document.getElementById('img-file').files[i])
      }

      axios
        .post(url + 'uploadDirectorioImg.php', data, {
          // receive two parameter endpoint url ,form data
        })
        .then(
          (res) => {
            // then print response status
            // console.log(res.data)
            // setConceptos(res.data.data)
            // handleCloseNewConcepto()
            // console.log(res.data)
            // document
            //   .getElementById('lifestyle-img-fondo')
            //   .setAttribute('src', res.data.data[1].url)
            document.getElementsByName('img-file')[0].value = null
            // setSpinnerIsActive(false)
            setShowAlertSuccess(true)

            clearTimerRef.current = setTimeout(function () {
              setShowAlertSuccess(false)
            }, 3000)
          },
          (error) => {
            alert(error)
          }
        )
    } else {
      console.log('vacío')
    }
  }

  return (
    <div className='row g-5'>
      <DirectorioBanner />

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 video-banner'>
          <div className='card-header'>
            <h3 className='card-title'>Directorio</h3>
            <h5 className='card-subtitle'>
              Descarga el archivo csv para realizar las modificaciones correspondientes.
            </h5>
            <h5 className='card-subtitle'>
              Las imágenes deben tener un formato horizontal, con una medida mínima de 500px de
              ancho y no pesar más de 1MB
            </h5>
            <div className='mt-n20 mb-10 float-end'>
              <button
                type='button'
                className='btn btn-primary'
                onClick={() => downloadCSV(urlCsv, 'locales-coordenadas.csv')}
              >
                Descargar CSV
              </button>
            </div>
          </div>
          <div className='card-body'>
            <div className='row mb-10'>
              <div className='col-md-12'>
                <h3>Locales</h3>
                <div className='row mb-10'>
                  <div className='form-group col-md-10'>
                    <label>Archivo csv:</label>
                    <input
                      type='file'
                      className='form-control'
                      id='directorio-csv-file'
                      name='directorio-csv-file'
                      accept='.csv'
                    />
                  </div>
                  <div className='form-group col-md-2'>
                    <button
                      type='submit'
                      className='btn btn-primary mt-6'
                      onClick={() => uploadCsv()}
                    >
                      Guardar
                    </button>
                  </div>
                  <div id='videoHelp' class='form-text'>
                    Subir un archivo .csv, debe llamarse <b>locales-coordenadas.csv</b>
                    <p><b>NOTA: </b>Si el archivo fue editado en Excel se debe guardar como tipo <b>CSV codificado en UTF-8 (delimitado por comas) (.csv)</b></p>
                  </div>
                </div>

                <div className='row'>
                  <div className='form-group col-md-10'>
                    <label>Subir imagen:</label>
                    <input type='file' className='form-control' id='img-file' name='img-file' />
                  </div>
                  <div className='form-group col-md-2'>
                    <button
                      type='submit'
                      className='btn btn-primary mt-6'
                      onClick={() => uploadImage()}
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className='separator my-10'></div>

            <div className='row'>
              <div className='col-md-12'>
                <h3>Mapas</h3>
                <div className='row mb-10'>
                  <h5>Nivel 1</h5>
                  <div className='form-group col-md-2'>
                    <button
                      type='submit'
                      className='btn btn-primary mt-6'
                      onClick={() => downloadSVG(urlSVGnivel1, 'plantaalta-landmarks.svg')}
                    >
                      Descargar
                    </button>
                  </div>
                  <div className='form-group col-md-8'>
                    <label>Archivo svg:</label>
                    <input
                      type='file'
                      className='form-control'
                      id='directorio-svg-nivel1'
                      name='directorio-svg-nivel1'
                      accept='.svg'
                    />
                    <div id='videoHelp' class='form-text'>
                      Subir un archivo .svg, debe llamarse <b>plantaalta-landmarks.svg</b>
                    </div>
                  </div>
                  <div className='form-group col-md-2'>
                    <button
                      type='submit'
                      className='btn btn-primary mt-6'
                      onClick={() => uploadSVG('nivel1')}
                    >
                      Guardar
                    </button>
                  </div>
                </div>

                <div className='row mb-10'>
                  <h5>Nivel 2</h5>
                  <div className='form-group col-md-2'>
                    <button
                      type='submit'
                      className='btn btn-primary mt-6'
                      onClick={() => downloadSVG(urlSVGnivel2, 'nivel2-landmarks.svg')}
                    >
                      Descargar
                    </button>
                  </div>
                  <div className='form-group col-md-8'>
                    <label>Archivo svg:</label>
                    <input
                      type='file'
                      className='form-control'
                      id='directorio-svg-nivel2'
                      name='directorio-svg-nivel2'
                      accept='.svg'
                    />
                    <div id='videoHelp' class='form-text'>
                      Subir un archivo .svg, debe llamarse <b>nivel2-landmarks.svg</b>
                    </div>
                  </div>
                  <div className='form-group col-md-2'>
                    <button
                      type='submit'
                      className='btn btn-primary mt-6'
                      onClick={() => uploadSVG('nivel2')}
                    >
                      Guardar
                    </button>
                  </div>
                </div>

                <div className='row mb-10'>
                  <h5>Planta baja</h5>
                  <div className='form-group col-md-2'>
                    <button
                      type='submit'
                      className='btn btn-primary mt-6'
                      onClick={() => downloadSVG(urlSVGplantabaja, 'plantabaja-landmarks.svg')}
                    >
                      Descargar
                    </button>
                  </div>
                  <div className='form-group col-md-8'>
                    <label>Archivo svg:</label>
                    <input
                      type='file'
                      className='form-control'
                      id='directorio-svg-plantabaja'
                      name='directorio-svg-plantabaja'
                      accept='.svg'
                    />
                    <div id='videoHelp' class='form-text'>
                      Subir un archivo .svg, debe llamarse <b>plantabaja-landmarks.svg</b>
                    </div>
                  </div>
                  <div className='form-group col-md-2'>
                    <button
                      type='submit'
                      className='btn btn-primary mt-6'
                      onClick={() => uploadSVG('plantabaja')}
                    >
                      Guardar
                    </button>
                  </div>
                </div>

                <div className='row mb-10'>
                  <h5>Sótano</h5>
                  <div className='form-group col-md-2'>
                    <button
                      type='submit'
                      className='btn btn-primary mt-6'
                      onClick={() => downloadSVG(urlSVGsotano, 'sotano1-landmarks.svg')}
                    >
                      Descargar
                    </button>
                  </div>
                  <div className='form-group col-md-8'>
                    <label>Archivo svg:</label>
                    <input
                      type='file'
                      className='form-control'
                      id='directorio-svg-sotano'
                      name='directorio-svg-sotano'
                      accept='.svg'
                    />
                    <div id='videoHelp' class='form-text'>
                      Subir un archivo .svg, debe llamarse <b>sotano1-landmarks.svg</b>
                    </div>
                  </div>
                  <div className='form-group col-md-2'>
                    <button
                      type='submit'
                      className='btn btn-primary mt-6'
                      onClick={() => uploadSVG('sotano')}
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* <VideoUploader name='home-video-fondo' /> */}
          </div>
          <div className='card-footer'>
            <div className='form-check form-switch form-check-custom form-check-solid'>
              <input
                className='form-check-input'
                type='checkbox'
                value=''
                id='column-active'
                checked={checkDevMode}
                onChange={(e) => onChangeDevMode(e)}
              />
              <label className='form-check-label' for='column-active'>
                Habilitar coordenadas en mapa
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className='row alert-container'>
        {showAlertSuccess ? (
          <div className='alert alert-success alert-dismissible bg-success d-flex flex-column flex-sm-row p-5 mb-10 col-md-6'>
            <span className='svg-icon svg-icon-2hx svg-icon-light me-4 mb-5 mb-sm-0'>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                class='mh-50px'
              >
                <path
                  opacity='0.3'
                  d='M12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z'
                  fill='black'
                ></path>
                <path
                  d='M19 15V18C19 18.6 18.6 19 18 19H6C5.4 19 5 18.6 5 18V15C6.1 15 7 14.1 7 13V10C7 7.6 8.7 5.6 11 5.1V3C11 2.4 11.4 2 12 2C12.6 2 13 2.4 13 3V5.1C15.3 5.6 17 7.6 17 10V13C17 14.1 17.9 15 19 15ZM11 10C11 9.4 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7C10.3 7 9 8.3 9 10C9 10.6 9.4 11 10 11C10.6 11 11 10.6 11 10Z'
                  fill='black'
                ></path>
              </svg>
            </span>
            <div className='d-flex flex-column text-light pe-0 pe-sm-10'>
              <h3 className='mb-1'>Cambios guardados con éxito</h3>
            </div>
          </div>
        ) : (
          <div></div>
        )}{' '}
      </div>
    </div>
  )
}

export {Directorio}
